var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tooltip', {
    attrs: {
      "disabled": !_vm.isTruncated,
      "bottom": "",
      "max-width": "420",
      "content-class": "middle-ellipsis-text__tooltip"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          ref: "label",
          staticClass: "middle-ellipsis-text"
        }, 'span', attrs, false), on), [_vm._v(_vm._s(_vm.displayText))])];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.text))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }